const SESSION_KEY = "aim_session";
const TOKEN_KEY = "aim_token";
const EXP_KEY = "aim_exp";

export const Session = {
  set: (session, token, expiresInMinutes = 60) => {
    const expiryTime = Date.now() + expiresInMinutes * 60 * 1000;

    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
    sessionStorage.setItem(TOKEN_KEY, token);
    sessionStorage.setItem(EXP_KEY, expiryTime.toString());
      setTimeout(() => {
      Session.clear();
      window.location.href = "/login";
    }, expiresInMinutes * 60 * 1000);
  },

  get: () => {
    const data = sessionStorage.getItem(SESSION_KEY);
    return data ? JSON.parse(data) : null;
  },

  getToken: () => sessionStorage.getItem(TOKEN_KEY),

  isAuthenticated: () => {
    const token = sessionStorage.getItem(TOKEN_KEY);
    const exp = sessionStorage.getItem(EXP_KEY);

    if (!token || !exp) return false;

    if (Date.now() > Number(exp)) {
      Session.clear();
      return false;
    }

    return true;
  },

  getUserId: () => Session.get()?.userId,
  getUserName: () => Session.get()?.username,
  getEmail: () => Session.get()?.email,
  getRole: () => Session.get()?.roleName,
   getWorkspacesName: () => Session.get()?.workspaces,

  clear: () => {
    sessionStorage.removeItem(SESSION_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(EXP_KEY);
  }
};
